<template>
    <div class="">
        <div class="tab__header__accordion">
            <a href="#" class="tab__link flex justify-between" @click.prevent="active = !active">
                <strong>{{title}}</strong>
                <span class="down-Arrow" v-show="!active">
                    <ion-icon name="chevron-down-outline"></ion-icon>
                </span>
                <span class="up-Arrow" v-show="active"><ion-icon name="chevron-up-outline"></ion-icon></span>
            </a>
        </div>
        <div class="tab__content" v-show="active"><slot /></div>
    </div>
</template>

<script>
    export default {
        props: [
            'title'
        ],
        data() {
            return {
                active: false,
            }
        },
    }
</script>
